import React from 'react';

function Community() {
  return (
    <div className="community">
      <h2>Community</h2>
      <p>Connect with other developers!</p>
    </div>
  );
}

export default Community;